/**
 * Modal pro změnu vlastního hesla přihlášeného uživatele.
 * Funguje pro admina i muzikanta — mění heslo aktuálně přihlášeného účtu.
 * Otevři: openChangePasswordModal()
 */
import { supabase } from '../lib/supabase.js';

export function openChangePasswordModal() {
    const m = document.createElement('div');
    m.id = 'change-password-modal';
    m.className = 'modal-overlay open';
    m.innerHTML = `
        <div class="modal-window cp-window">
            <div class="modal-head">
                <h2>Změna hesla</h2>
                <button class="modal-close" type="button">×</button>
            </div>
            <div class="modal-body">
                <label class="cp-label">Nové heslo
                    <input type="password" id="cp-pass1" autocomplete="new-password"
                           placeholder="alespoň 6 znaků">
                </label>
                <label class="cp-label">Nové heslo znovu
                    <input type="password" id="cp-pass2" autocomplete="new-password"
                           placeholder="zopakuj heslo">
                </label>
                <label class="cp-show">
                    <input type="checkbox" id="cp-show"> Zobrazit heslo
                </label>
                <p class="cp-msg" id="cp-msg"></p>
            </div>
            <div class="modal-foot">
                <button class="btn" id="cp-cancel" type="button">Zrušit</button>
                <button class="btn btn-primary" id="cp-save" type="button">Uložit heslo</button>
            </div>
        </div>
    `;
    document.body.appendChild(m);

    const pass1 = m.querySelector('#cp-pass1');
    const pass2 = m.querySelector('#cp-pass2');
    const msg = m.querySelector('#cp-msg');
    const saveBtn = m.querySelector('#cp-save');

    function onEsc(e) { if (e.key === 'Escape') close(); }
    function close() {
        m.remove();
        document.removeEventListener('keydown', onEsc);
    }
    document.addEventListener('keydown', onEsc);
    m.querySelector('.modal-close').addEventListener('click', close);
    m.querySelector('#cp-cancel').addEventListener('click', close);
    m.addEventListener('click', (e) => { if (e.target === m) close(); });

    m.querySelector('#cp-show').addEventListener('change', (e) => {
        const type = e.target.checked ? 'text' : 'password';
        pass1.type = type;
        pass2.type = type;
    });

    const setMsg = (text, ok) => {
        msg.textContent = text;
        msg.className = 'cp-msg ' + (ok ? 'cp-ok' : 'cp-err');
    };

    async function save() {
        const p1 = pass1.value;
        const p2 = pass2.value;
        if (p1.length < 6) { setMsg('Heslo musí mít alespoň 6 znaků.', false); return; }
        if (p1 !== p2) { setMsg('Hesla se neshodují.', false); return; }

        saveBtn.disabled = true;
        setMsg('Ukládám…', true);
        const { error } = await supabase.auth.updateUser({ password: p1 });
        if (error) {
            setMsg('Chyba: ' + error.message, false);
            saveBtn.disabled = false;
            return;
        }
        setMsg('Heslo bylo změněno ✓', true);
        setTimeout(close, 1400);
    }

    saveBtn.addEventListener('click', save);
    [pass1, pass2].forEach((el) => el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') save();
    }));

    pass1.focus();
}
